import { UPDATE_MODEL_VALUE } from '../../constants';
import { type PropType } from 'vue';

export interface CheckboxProps {
    modelValue: boolean,
    readonly?: boolean,
    disabled?: boolean,
    indeterminate?: boolean,
}

export const checkboxProps = {
    modelValue: {
        type: Boolean as PropType<CheckboxProps['modelValue']>,
        default: undefined,
        required: true,
    },
    readonly: {
        type: Boolean as PropType<CheckboxProps['readonly']>,
        default: undefined,
        required: false,
    },
    disabled: {
        type: Boolean as PropType<CheckboxProps['disabled']>,
        default: undefined,
        required: false,
    },
    indeterminate: {
        type: Boolean as PropType<CheckboxProps['indeterminate']>,
        default: undefined,
        required: false,
    },
};

export const checkboxEmits = {
    [UPDATE_MODEL_VALUE]: (event: boolean) => event,
    change: (event: boolean) => event,
};
